import React from "react";
import Style from "./course.module.scss";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { ThemeContext } from "../../../../context/theme/ThemeContext";
import { Link, useLocation, useHistory } from "react-router-dom";
import { HeaderText } from "../../../../components";
import "./course.css";

function CourseStudentCard(props) {
  const { theme, changeTheme } = React.useContext(ThemeContext);
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#f4f4f4",
      borderColor: "#006D5B"
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#f25f37" : "#f25f37",
    },
  }));
  const { item, progress, link, pending, list } = props;

  return (
    <div className={`col-xs-12 col-sm-6 col-md-${list} border`}>
      <Link to={link ? link : ''} className="mc-learning-item mc-item mc-item-2">
        <div className="image-heading">
          <img src={
            item?.poster?.storage === "local"
              ? process.env.REACT_APP_LOCAL_FILE_PATH +
              item?.poster?.path +
              "/medium/" +
              item?.poster?.name
              : item?.poster?.path
          } alt="" />
        </div>
        <div className="meta-categories"><a href="#">{item?.course_section?.length} Sections</a></div>
        <div className="content-item">
          <div className="image-author">
            {/* <img src="images/avatar-1.jpg" alt="" /> */}
          </div>
          <h4> <Link to={link ? link : ''} >{item?.title}</Link></h4>
          {progress && <div className="name-author">
            By <a href="#">{item?.created_by?.first_name}</a>
          </div>}
        </div>
        <div className="ft-item">
          {item?.course_section_item?.length &&
            <div className="percent-learn-bar">
              <BorderLinearProgress
                variant="determinate"
                value={(progress / item?.course_section_item?.length) * 100}
              />
            </div>}
          { item?.course_section_item?.length && <div className="percent-learn">{Math.round((progress / item?.course_section_item?.length) * 100>100?100:(progress / item?.course_section_item?.length) * 100).toFixed(2)}%<i className="fa fa-trophy" /></div>}
        {!progress && !item?.course_section_item?.length &&
          <div className="rating">
            <a href="#" className="active" />
            <a href="#" className="active" />
            <a href="#" className="active" />
            <a href="#" className="active" />
            <a href="#" />
          </div>}
        <div className="price">
          <a className="learnnow">Learn now<i className="mdi mdi-play-circle" /></a>
        </div>
    </div>
      </Link >
    </div >

  );
}

export default CourseStudentCard;
